import { memo, useEffect, useState } from "react";
import { useQuery } from "react-query";
import mdlReservationCustomerDetailRequest from "../../models/service-models/reservation/ReservationCustomerDetailRequest";
import { ReservationService } from "../../services/ReservationService";
import { Skeleton, Table, TableColumnsType } from "antd";
import { mdlCustomer } from "../../models/domain/Customer";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { StopFreeSaleService } from "../../services/StopFreeSaleService";
import { mdlStopFreeSaleDetailRequest } from "../../models/service-models/stop-free-sale/StopFreeSaleDetailRequest";
import { mdlStopFreeSale } from "../../models/domain/StopFreeSale";
import { mdlStopFreeSaleDetail } from "../../models/domain/StopFreeSaleDetail";

export type ExpandableStopFreeSaleSendedListProps = {
    id?: string;
}

export const ExpandableStopFreeSaleSendedList = memo(function ExpandableStopFreeSaleSendedList(props: ExpandableStopFreeSaleSendedListProps) {
    const { t } = useTranslation();

    useEffect(() => {
        if (!data && props.id)
            refetch();
    }, [props]);

    const {
        data,
        isLoading,
        isError,
        refetch
    } = useQuery(
        ["getDetail", props.id],
        () => {
            if (props.id) {
                var request: mdlStopFreeSaleDetailRequest = { stopFreeId: props.id };
                return StopFreeSaleService.GetDetail(request);
            }
        },
        {
            refetchOnWindowFocus: false,
            enabled: false,
        }
    );

    const expandColumns: TableColumnsType<mdlStopFreeSaleDetail> = [
        {
            children: [
                { title: t("stopFreeSaleTable.agency"), dataIndex: 'agencyName', key: 'agencyName' },
                { title: t("stopFreeSaleTable.market"), dataIndex: 'marketName', key: 'marketName' },
                { title: t("stopFreeSaleTable.room"), dataIndex: 'roomName', key: 'roomName' },
                { title: t("stopFreeSaleTable.sendDate"), dataIndex: 'sendDate', key: 'sendDate' ,
                    render: (e: mdlStopFreeSaleDetail) => {
                        try{
                            return `${dayjs(e.sendDate).format("DD.MM.YYYY")} - ${dayjs(e.sendDate).format("DD.MM.YYYY")}`;
                        }catch{
                            return <></>
                        }
                    }
                },
                { title: t("stopFreeSaleTable.sejourImportedDate"), dataIndex: 'sejourImportedDate', key: 'sejourImportedDate' ,
                    render: (e: mdlStopFreeSaleDetail) => {
                        try{
                            return `${dayjs(e.sejourImportedDate).format("DD.MM.YYYY")} - ${dayjs(e.sejourImportedDate).format("DD.MM.YYYY")}`;
                        }catch{
                            return <></>
                        }
                    }
                },
                { title: t("stopFreeSaleTable.receiveDate"), dataIndex: 'receiveDate', key: 'receiveDate' ,
                    render: (e: mdlStopFreeSaleDetail) => {
                        try{
                        return `${dayjs(e.receiveDate).format("DD.MM.YYYY")} - ${dayjs(e.receiveDate).format("DD.MM.YYYY")}`;
                        }catch{
                            return <></>
                        }
                    }
                },
                { title: t("stopFreeSaleTable.sendStatus"), dataIndex: 'sendStatus', key: 'sendStatus' ,
                    render: (e: string) => {
                        return  e == "[#JLangStopFreeNotSended#]" ? t("stopFreeSaleTable.notSended") : e == "[#JLangStopFreeSending#]" ? t("stopFreeSaleTable.sending") : t("stopFreeSaleTable.sended")
                    }},
            ]
        }
    ];

    return (
        <>

            {
                isLoading
                &&
                <Skeleton active />
            }
            {
                data
                &&
                <>
                <Table<mdlStopFreeSaleDetail>
                    columns={expandColumns}
                    dataSource={data!.body!.data}
                    pagination={false}
                />

</>
            }
        </>
    )
})